<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card>
        <vx-card class="mb-3" noShadow cardBorder>
          <div class="vx-row">
            <div class="vx-col w-1/3 text-xl font-bold">
              <span class="italic text-primary mr-4">Total customer contact actions:</span> {{ summary.count }}
            </div>
          </div>
        </vx-card>
        <vx-card class="p-4 mb-3" noShadow cardBorder>
          <div class="vx-row mb-3">
            <div class="w-full vx-col md:w-1/4 sm:w-1/3">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="w-full mb-4 md:mb-0" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <customer-dropdown v-on:onInput="value => filters['customer_id'] = value ? value.id : null"
                :selected_customer_data="filters['customer_id']" :field_label="'Customer'" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/3 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
            </div>

            <div class="vx-col md:w-1/4 sm:w-1/3 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Country</label>
              <v-select name="country" :closeOnSelect="false" :clearable="false" v-model="filters['countries']"
                :options="countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.name" label="name"
                multiple />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Account Handler</label>
              <v-select :disabled="!$can('executive-admin')" name="staffs" :closeOnSelect="false" :clearable="false"
                v-model="filters['account-handler-ids']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Related Staff members</label>
              <v-select name="staffs" :closeOnSelect="false" :clearable="false" v-model="filters['related-staff-ids']"
                :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" label="name" multiple />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Industrial Sector</label>
              <v-select name="industry_sectors" :closeOnSelect="false" :clearable="false"
                v-model="filters['industry-sector']" :options="industry_sectors" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/3 w-full">
              <label class="text-sm opacity-100 text-bold">Contact Type</label>
              <v-select :options="['email', 'event', 'call', 'f2f-meeting', 'other']" v-model="filters['type']" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/3 w-full hidden">
              <label class="text-sm opacity-100 text-bold">Customer Stage</label>
              <v-select :options="['customer', 'subscriber' ,'lead', 'opportunity']" v-model="filters['stage']" />
            </div>
          </div>
          <div class="mt-5 vx-row">
            <div class="w-full ml-auto vx-col">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="clearFilters()">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card noShadow cardBorder>
          <div class="vx-row text-xl">
              <div class="vx-col md:w-1/3 w-1/2 font-bold">
                <span class="italic text-warning mr-4">Filtered view - Total customer contact actions:</span> {{ filtered_summary.count }}
              </div>
            </div>
        </vx-card>

        <div id="incoterms-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th sort-key="code" width="10%">CONTACT CODE</vs-th>
                <vs-th width="10%">CONTACT TYPE</vs-th>
                <vs-th WIDTH="10%">CREATED DATE/TIME</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th width="10%">FOLLOW UP TIMESTAMP</vs-th>
                <vs-th width="20%">SUBJECT</vs-th>
                <vs-th width="15%">CUSTOMER</vs-th>
                <vs-th width="10%">NEXT ACTION</vs-th>
                <vs-th width="5%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(data[indextr].id, data[indextr].type, data[indextr].customer.id)"
                  class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].created_by_staff }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].follow_up_timestamp }}
                  </vs-td>

                  <vs-td :data="data[indextr].subject">
                    {{ data[indextr].subject || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <span class="text-primary cursor-pointer">
                      {{ data[indextr].customer.company_name }} <br> {{ data[indextr].customer.account_number }}
                    </span>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].notes || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button
                          @click.stop="onClickUpdate(data[indextr].id, data[indextr].type, data[indextr].customer.id)"
                          class="ml-3" size="small" color="warning" type="border" icon-pack="feather"
                          icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <create-customer-crm-contact-pop-up ref="createCustomerCrmContactPopUp" :customer_id="customerId" />
  </div>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import CreateCustomerCrmContactPopUp from '@/components/popups/crm/customer/contacts/CreateCustomerCrmContactPopUp.vue'

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
const CrmRepository = RepositoryFactory.get('crm');
import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "CustomerCommunicationAggregatedActivity",
  data() {
    return {
      incoterms: [],
      filters: {
        customer_id: null,
        'account-handler-ids': null
      },
      summary: {
        count: 0,
      },
      filtered_summary: {
        count: 0
      },
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      customerId: null,
    }
  },
  components: {
    CreateCustomerCrmContactPopUp,
    'v-select': vSelect,
    flatPickr,
    CustomerDropdown
  },
  created() {
    if(!this.$can('executive-admin')) {
      this.filters['account-handler-ids'] = [this.$store.getters.currentUserId]
    }
  },
  methods: {
    ...mapActions(['fetchStaffs', 'fetchIndustrySections', 'fetchCountries']),
    async refreshData() {
      await this.fetchCustomerContactLIst()
      // await this.$emit('refreshSummary')
    },
    async fetchCustomerContactLIst() {
      await this.$vs.loading({
        container: '#incoterms-table',
        scale: 0.45
      })
      try {
        const { data } = await CrmRepository.getListOfCustomerCommunicationActivities(this.page, this.filterQuery, this.perPage)
        this.incoterms = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close('#incoterms-table > .con-vs-loading')
    },
    async fetchSummary() {
      try {
        const { data } = (await CrmRepository.getContactSummary()).data
        this.summary = data
      } catch (error) {

      }
    },
    async fetchFilteredSummary() {
      try {
        const { data } = (await CrmRepository.getContactSummary(this.filterQuery)).data
        this.filtered_summary = data
      } catch (error) {

      }
    },
    async onClickUpdate(id, contact_type, customer_id) {
      this.customerId = customer_id
      await this.$refs.createCustomerCrmContactPopUp.openPopup(contact_type, id)
    },
    filterQueryUpdate() {
      this.page = 1
      this.fetchCustomerContactLIst()
      this.fetchFilteredSummary()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchCustomerContactLIst()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchCustomerContactLIst()
      }
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    clearFilters() {
      this.filters = this.$can('executive-admin') 
        ? { customer_id: null } 
        : { 'account-handler-ids': [this.$store.getters.currentUserId] , customer_id: null };
    }
  },
  async mounted() {
    await this.fetchStaffs()
    await this.fetchIndustrySections()
    await this.fetchCountries()
    await this.fetchSummary()
  },
  computed: {
    ...mapGetters(['staffs', 'industry_sectors', 'countries'])
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchCustomerContactLIst()
    },
    perPage() {
      this.fetchCustomerContactLIst()
    }
  }
}
</script>
  
<style scoped></style>
  